export const EighthInches = Object.freeze([0.0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875]);
export const EighthInchLabels = Object.freeze({
  0.0: '0/0',
  0.125: '1/8',
  0.25: '1/4',
  0.375: '3/8',
  0.5: '1/2',
  0.625: '5/8',
  0.75: '3/4',
  0.875: '7/8'
});
export const getInch = fInches => Math.floor(fInches);
export const getInchDecimal = fInches => fInches - getInch(fInches);
export const sizeFormat = value => {
  const inches = getInch(value);
  const eighths = getInchDecimal(value);
  return `${inches} ${EighthInchLabels[eighths]}`;
};
export const sizeSplit = value => {
  const inches = getInch(value);
  const eighths = getInchDecimal(value);
  return {
    wholes: inches,
    eighths
  };
};
export const sizeJoin = sizeObject => sizeObject.wholes + parseFloat(sizeObject.eighths);